import {
  ReportMealsTabFoods,
  ReportMealsTabGroceries,
  ReportMealsTabRestaurants,
  ReportMealsTabNonRegistered,
} from "@/components/report/meals";

import ReportDesktopTaken from "./screens/ReportDesktopTaken.vue";
import ReportDesktopEmployees from "./screens/ReportDesktopEmployees.vue";
import ReportDesktopMeals from "./screens/ReportDesktopMeals.vue";
import ReportDesktopPackages from "./screens/ReportDesktopPackages.vue";
import ReportDesktopWorkerOrders from "./screens/ReportDesktopWorkerOrders.vue";
import ReportDesktopAllSummary from "./screens/ReportDesktopAllSummary.vue";
import ReportDesktopAllPacking from "./screens/ReportDesktopAllPacking.vue";
import ReportDesktopOrdered from "./screens/ReportDesktopOrdered.vue";
import ReportDesktopGroupMeals from "./screens/group/ReportDesktopGroupMeals.vue";
import ReportDesktopGroupGrouped from "./screens/group/ReportDesktopGroupGrouped.vue";
import ReportDesktopGroupUsers from "./screens/group/ReportDesktopGroupUsers.vue";
import ReportDesktopGroupOrdered from "./screens/group/ReportDesktopGroupOrdered.vue";
import ReportDesktopGroupOrderers from "./screens/group/ReportDesktopGroupOrderers.vue";
import ReportDesktopGroupReserved from "./screens/group/ReportDesktopGroupReserved.vue";
import ReportDesktopGroupTaken from "./screens/group/ReportDesktopGroupTaken.vue";
import ReportDesktopGroupRestaurants from "./screens/group/ReportDesktopGroupRestaurants.vue";
import ReportDesktopMoreMeals from "./screens/more/ReportDesktopMoreMeals.vue";
import ReportDesktopMoreDishes from "./screens/more/ReportDesktopMoreDishes.vue";
import ReportDesktopMoreEmployees from "./screens/more/ReportDesktopMoreEmployees.vue";
import ReportDesktopMoreWorkerItems from "./screens/more/ReportDesktopMoreWorkerItems.vue";
import ReportDesktopMoreCredit from "./screens/more/ReportDesktopMoreCredit.vue";
import ReportDesktopMorePackages from "./screens/more/ReportDesktopMorePackages.vue";
import { ReportDesktopReserved, ReportDesktopTakenMeals } from "./screens/legacyBridges";

export const VIEW_MEALS = 1;
export const VIEW_GROUPS = 2;
export const VIEW_MORE_RESTAURANTS = 3;
export const VIEW_ALL_COMPANIES = 4;

/**
 * Izveštaji računara. Ključevi prvog prikaza su isti kao na telefonu (?r=taken radi svuda).
 *   companies: false | true (više firmi) | "single" (jedna firma)
 *   companySource: "food" = firme tipa grupa (prikaz Jela iz grupa), "multi" = firme sa ugovorom "više restorana"
 *                  (prikaz Firme koje hrani restoran), inače sve firme restorana
 *   shifts:    da li se izbor smena u traci odnosi na izveštaj
 *   legacy:    stari tab u novoj ljusci (svoje učitavanje, štampa, Excel i svoji izbori)
 * Ekrani koji nisu legacy dobijaju prop `shifts`, a iz store-a čitaju period, firme i pretragu.
 */
export const buildScreens = (t) => ({
  // ---- Komplet obroci
  groceries: { title: t("groceri"), icon: "mdi-leaf", component: ReportMealsTabGroceries, legacy: true },
  foods: { title: t("meals_main"), icon: "mdi-pot-steam-outline", component: ReportMealsTabFoods, legacy: true },
  meals: { title: t("meals"), icon: "mdi-bowl-mix-outline", component: ReportDesktopMeals, companies: true, shifts: true },
  workerOrders: { title: t("report_mobile.worker_orders"), icon: "mdi-table", component: ReportDesktopWorkerOrders, companies: true, shifts: true },
  employees: { title: t("employees"), icon: "mdi-account-outline", component: ReportDesktopEmployees, companies: "single" },
  reserved: { title: t("report_mobile.reserves"), icon: "mdi-archive-outline", component: ReportDesktopReserved, legacy: true, companies: true },
  packages: { title: t("pak"), icon: "mdi-shopping-outline", component: ReportDesktopPackages, companies: true, shifts: true },
  taken: { title: t("taken"), icon: "mdi-truck-outline", component: ReportDesktopTaken, shifts: true },
  takenMeals: { title: t("t_o"), icon: "mdi-check-circle-outline", component: ReportDesktopTakenMeals, legacy: true, companies: true, shifts: true },
  ordered: { title: t("warehouse.ordered"), icon: "mdi-grid", component: ReportDesktopOrdered, companies: "single", shifts: true, daily: true },
  nonRegistered: { title: t("un"), icon: "mdi-account-question-outline", component: ReportMealsTabNonRegistered, legacy: true },
  restaurants: { title: t("restaurants"), icon: "mdi-storefront-outline", component: ReportMealsTabRestaurants, legacy: true },

  // ---- Jela iz grupe
  groupMeals: { title: t("meals_main"), icon: "mdi-food-drumstick", component: ReportDesktopGroupMeals, companies: true, companySource: "food", shifts: true },
  groupUsers: { title: t("users"), icon: "mdi-account-multiple", component: ReportDesktopGroupUsers, companies: "single", companySource: "food" },
  groupOrdered: { title: t("ordered_1"), icon: "mdi-grid", component: ReportDesktopGroupOrdered, companies: "single", companySource: "food", daily: true },
  groupTaken: { title: t("ordered_taken_meals"), icon: "mdi-truck-delivery", component: ReportDesktopGroupTaken, shifts: true },
  groupOrderers: { title: t("orderers"), icon: "mdi-format-list-bulleted-type", component: ReportDesktopGroupOrderers, companies: "single", companySource: "food", daily: true },
  groupReserved: { title: t("r_o"), icon: "mdi-food-variant", component: ReportDesktopGroupReserved, companies: true },
  groupRestaurants: { title: t("restaurants"), icon: "mdi-storefront-outline", component: ReportDesktopGroupRestaurants },
  groupGrouped: { title: t("groups_meal"), icon: "mdi-view-grid-plus", component: ReportDesktopGroupGrouped, companies: true, companySource: "food", shifts: true },

  // ---- Firme koje hrani restoran
  moreMeals: { title: t("meals"), icon: "mdi-bowl-mix-outline", component: ReportDesktopMoreMeals, companies: true, companySource: "multi", shifts: true },
  morePacking: { title: t("pak"), icon: "mdi-shopping-outline", component: ReportDesktopMorePackages, props: { packing: true }, companies: true, companySource: "multi", shifts: true },
  moreEmployees: { title: t("employees"), icon: "mdi-account-outline", component: ReportDesktopMoreEmployees, companies: "single", companySource: "multi", shifts: true },
  moreCredit: { title: t("credit_users"), icon: "mdi-account-cash-outline", component: ReportDesktopMoreCredit, companies: "single", companySource: "multi" },
  moreTaken: { title: t("taken_meals"), icon: "mdi-food-takeout-box-outline", component: ReportDesktopMorePackages, companies: true, companySource: "multi", shifts: true },
  moreDishes: { title: t("meals_main"), icon: "mdi-pot-steam-outline", component: ReportDesktopMoreDishes, companies: true, companySource: "multi", shifts: true },
  moreWorkerItems: {
    title: t("more_restaurants_report.worker_items_tab"),
    icon: "mdi-account-details-outline",
    component: ReportDesktopMoreWorkerItems,
    companies: "single",
    companySource: "multi",
    shifts: true,
  },

  // ---- Sve firme – zbirni izveštaj
  allMeals: { title: t("meals"), icon: "mdi-bowl-mix-outline", component: ReportDesktopAllSummary, props: { mode: "meals" }, shifts: true },
  allCompanies: { title: t("companies"), icon: "mdi-domain", component: ReportDesktopAllSummary, props: { mode: "companies" }, shifts: true },
  allPacking: { title: t("pak"), icon: "mdi-shopping-outline", component: ReportDesktopAllPacking, shifts: true, bindSelectedShifts: true },
});

/** Grupe menija po prikazu: [{ key, title, items: [ključevi izveštaja] }] */
export const buildMenus = (t) => {
  const group = (key, titleKey, items) => ({ key, title: t(titleKey), items });
  return {
    [VIEW_MEALS]: [
      group("kitchen", "report_mobile.groups.kitchen", ["groceries", "foods", "meals"]),
      group("orders", "report_mobile.groups.orders", ["workerOrders", "employees", "reserved"]),
      group("handout", "report_mobile.groups.handout", ["packages", "taken", "takenMeals"]),
      group("other", "report_mobile.groups.other", ["ordered", "nonRegistered", "restaurants"]),
    ],
    [VIEW_GROUPS]: [
      group("kitchen", "report_mobile.groups.kitchen", ["groupMeals", "groupGrouped"]),
      group("orders", "report_mobile.groups.orders", [
        "groupUsers",
        "groupOrdered",
        "groupOrderers",
        "groupReserved",
      ]),
      group("handout", "report_mobile.groups.handout", ["groupTaken"]),
      group("other", "report_mobile.groups.other", ["groupRestaurants"]),
    ],
    [VIEW_MORE_RESTAURANTS]: [
      group("kitchen", "report_mobile.groups.kitchen", ["moreMeals", "moreDishes"]),
      group("orders", "report_mobile.groups.orders", ["moreEmployees", "moreWorkerItems", "moreCredit"]),
      group("handout", "report_mobile.groups.handout", ["morePacking", "moreTaken"]),
    ],
    [VIEW_ALL_COMPANIES]: [
      group("all", "all_companies_summary_report", ["allMeals", "allCompanies", "allPacking"]),
    ],
  };
};

/**
 * "Dodaj obrok" (zaglavlje) vodi na isti izveštaj kao danas: u prikazu 1 na Pakovanje,
 * u prikazu 3 na "Preuzeti obroci" (stari tab sa indeksom 4). U prikazima 2 i 4 dugme se ne prikazuje.
 */
export const ADD_MEAL_TARGET = {
  [VIEW_MEALS]: "packages",
  [VIEW_MORE_RESTAURANTS]: "moreTaken",
};

/** Izveštaj koji se otvara kad adresa nema (ili ima neispravan) ?r= */
export const DEFAULT_SCREEN = {
  [VIEW_MEALS]: "meals",
  [VIEW_GROUPS]: "groupMeals",
  [VIEW_MORE_RESTAURANTS]: "moreMeals",
  [VIEW_ALL_COMPANIES]: "allMeals",
};

/** Stari tabovi javljaju "switch-tab" sa indeksom u starom redosledu (prikaz 2). */
export const LEGACY_TAB_KEYS = {
  [VIEW_GROUPS]: [
    "groupMeals",
    "groupUsers",
    "groupOrdered",
    "groupTaken",
    "groupOrderers",
    "groupReserved",
    "groupRestaurants",
    "groupGrouped",
  ],
};
